import React from "react";
import { themes } from "../../theme";

const LogoIconGGV = ({
  height = "40px",
  primaryColor = themes.GGV.palette.primary.main,
  secondaryColor = themes.GGV.palette.custom.secondary
}) => {
  return (
    <svg
      style={{ height }}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 155 91"
    >
      <path
        d="M150.8 27.8c-2.3-5.5-5.6-10.2-9.8-14.3-4.2-4.1-9.2-7.3-15-9.6-5.8-2.3-12.1-3.4-19-3.5H48c-6.9 0-13.3 1.2-19.1 3.5-5.8 2.3-10.7 5.5-14.9 9.6-4.2 4.1-7.4 8.9-9.7 14.3C2 33.3.8 39.2.8 45.5c0 6.3 1.2 12.3 3.5 17.7 2.3 5.5 5.6 10.2 9.7 14.3.2.2.4.4.7.6V89c0 .8.7 1.5 1.5 1.5H107c6.8 0 13.2-1.2 19-3.5 5.8-2.3 10.8-5.5 15-9.6 4.2-4.1 7.5-8.9 9.8-14.3 2.3-5.5 3.5-11.4 3.5-17.7 0-6.3-1.2-12.2-3.5-17.6z"
        fill={secondaryColor}
      />
      <path
        d="M73.7 45.5H48c-.7 0-1 .8-.5 1.3l8.7 8.7c-2.7 2.7-6.5 4.4-10.7 4.2-7.4-.3-13.4-6.3-13.7-13.7-.3-8.1 6.2-14.8 14.2-14.8 5.7 0 10.7 3.4 12.9 8.3.2.4.5.6.9.6h12.6c.7 0 1.1-.6 1-1.3-2.9-12.1-13.7-21.2-26.7-21.6-15.5-.4-28.7 12-29 27.5-.4 15.9 12.4 28.9 28.2 28.9 7.8 0 14.9-3.2 20-8.3l7 7c.5.5 1.3.1 1.3-.5V46.1c.2-.3-.1-.6-.5-.6zM108.9 17.2c-15.6 0-28.2 12.6-28.2 28.2s12.6 28.2 28.2 28.2 28.2-12.6 28.2-28.2c.1-15.5-12.6-28.2-28.2-28.2z"
        fill={primaryColor}
      />
      <path d="M102.551 40.62l-7 7.001 7 7 7-7-7-7z" fill={secondaryColor} />
      <path
        d="M95.7 47.8l-5.9-5.9c-.6-.6-.6-1.5 0-2.1l4.8-4.8c.6-.6 1.5-.6 2.1 0l5.9 5.9-6.9 6.9zM108.4 60.5l-5.9-5.9 7-7 7 7-5.9 5.9c-.6.6-1.6.6-2.2 0z"
        fill={secondaryColor}
      />
      <path
        d="M123.441 47.636l-7-7-7.001 7 7.001 7 7-7z"
        fill={secondaryColor}
      />
      <path
        d="M123.4 47.6l-7-7 5.9-5.9c.6-.6 1.5-.6 2.1 0l4.8 4.8c.6.6.6 1.5 0 2.1l-5.8 6z"
        fill={secondaryColor}
      />
    </svg>
  );
};

export { LogoIconGGV };
